import { render } from "./StatsAggregationDisplay.vue?vue&type=template&id=ebe35c80"
import script from "./StatsAggregationDisplay.vue?vue&type=script&lang=js"
export * from "./StatsAggregationDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__